// import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router";
import About from "./pages/About";
import Home from "./pages/Home";
import Services from "./pages/Services";
import PublicLayout from "./layout/PublicLayout";
import ReactLenis from "lenis/react";
import ScrollToTop from "./components/ScrollToTop";
import Entitlement from "./pages/Entitlement";
import Thanks from "./pages/Thanks";
import Consultation from "./pages/Consultation";
import Faqs from "./pages/Faqs";
import Projects from "./pages/Projects";

function App() {
  return (
    <>
      <ScrollToTop />
      <ReactLenis root options={{ autoRaf: true }} />
      <Routes>
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="projects" element={<Projects/>}/>
          <Route path="consultation" element={<Consultation/>} />
          <Route path="faqs" element={<Faqs/>}/>
          <Route path="entitlement" element={<Entitlement />} />
          <Route path="thanks" element={<Thanks/>}/>
        </Route>
        {/* <Route path="entitlement" element={<PublicLayout/>}>
        </Route> */}
      </Routes>
    </>
  );
}

export default App;
